<a
  *ngFor="let breadcrumb of breadcrumbs"
  [routerLink]="breadcrumb.url"
  class="breadcrumb"
>
  {{ breadcrumb.label }}
</a>
